import { Theme } from "@mui/material/styles";
import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles((theme: Theme) => ({
  alertPeopleInsight: {
    padding: theme.spacing(1, 0),
    backgroundColor: "#e9e7f6",
  },
}));
